import BranchesPage from "../../components/Branches/BranchesPage";

const BranchesContainer = () => {
  return <BranchesPage />;
};

export default BranchesContainer;
